import { getApiUrl, getAuthHeaders, handleApiResponse } from '../config/api';

export interface DashboardStats {
  doctors: {
    total: number;
    active: number;
    pending: number;
  };
  patients: {
    total: number;
    active: number;
  };
  appointments: {
    total: number;
    pending: number;
    confirmed: number;
    completed: number;
    cancelled: number;
    last7Days: number;
    change: number;
  };
  reviews: {
    total: number;
    active: number;
    last7Days: number;
    change: number;
  };
  revenue: {
    totalBalance: number;
    totalEarned: number;
    totalWithdrawn: number;
    totalHoldBalance: number;
  };
  withdrawals: {
    total: number;
    pending: number;
    approved: number;
    rejected: number;
  };
}

export interface DashboardCharts {
  appointmentsByServiceType: Array<{
    name: string;
    value: number;
  }>;
  appointmentsTrend: Array<{
    date: string;
    count: number;
  }>;
}

export interface RecentActivity {
  id: number;
  type: string;
  name: string;
  action: string;
  time: string | Date;
  avatar: string;
}

export interface DashboardData {
  stats: DashboardStats;
  charts: DashboardCharts;
  recentActivities: RecentActivity[];
}

export interface DashboardResponse {
  success: boolean;
  message: string;
  data: DashboardData;
}

export const dashboardService = {
  /**
   * Get dashboard statistics
   */
  async getDashboardStats(): Promise<DashboardResponse> {
    const response = await fetch(getApiUrl('/admin/dashboard/stats'), {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    return handleApiResponse(response);
  },
};

